import { useEffect } from 'react'

const FONTS_HREF = 'https://fonts.googleapis.com/css2?family=Baloo+2:wght@600;700;800&family=Nunito+Sans:wght@400;600;700;800&display=swap'

// Loads the brand fonts; `noindex` keeps internal preview pages out of search.
export const useBrandHead = ({ noindex = false }: { noindex?: boolean } = {}) => {
  useEffect(() => {
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = FONTS_HREF
    document.head.appendChild(link)

    const robots = document.createElement('meta')
    if (noindex) {
      robots.name = 'robots'
      robots.content = 'noindex, nofollow'
      document.head.appendChild(robots)
    }

    return () => {
      document.head.removeChild(link)
      if (noindex) document.head.removeChild(robots)
    }
  }, [ noindex ])
}
